import React from 'react';
/**
 * icon-image-enlarge-m
 * icon-image-enlarge
 */
export default ({ rootClassName }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        className={rootClassName}
    >
        <path
            d="M10.276 1.519a.498.498 0 0 0-.287.753c.043.06.126.135.184.166.103.053.149.056 1.359.063l1.252.008-2.003 2.006C9.68 5.618 8.764 6.55 8.745 6.587a.607.607 0 0 0-.034.216c0 .329.276.541.615.471.123-.025.191-.089 2.146-2.042l2.019-2.015.008 1.265.008 1.265.062.099c.238.383.815.295.908-.138.041-.191.041-3.625 0-3.816a.487.487 0 0 0-.351-.368c-.14-.035-3.704-.04-3.85-.005M6.733 8.706a1.491 1.491 0 0 1-.106.027c-.06.013-.582.518-2.1 2.035l-2.02 2.018v-1.178c0-.76-.011-1.228-.03-1.316-.094-.437-.668-.525-.908-.138l-.062.099v3.902l.08.114a.656.656 0 0 0 .186.169c.105.054.14.055 1.945.063 1.284.005 1.882-.002 1.983-.023.501-.103.52-.829.025-.954-.084-.021-.5-.031-1.317-.031H3.214l2.017-2.02c1.954-1.956 2.018-2.024 2.043-2.147.047-.228-.036-.439-.214-.548-.083-.05-.271-.092-.327-.072"
            fill-rule="evenodd"
            fill="#1A2B49"
        />
    </svg>
);
